import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '@/config'
import Main from '@/components/common/main'
import mananger from './manager'
import webview from './webview'
import front from './front'

Vue.use(VueRouter)

const routes = [
    ...mananger,
    ...webview,
    ...front,
    {
        path: '/admin/login',
        name: 'Login',
        component: () => import('@/views/login.vue')
    },
    {
        path: '/admin/singleSignOn',
        name: 'SingleSignOn',
        component: () => import('@/views/mlogin.vue')
    },
    {
        path: '/home',
        component: Main,
        children: [
            {
                path: '',
                component: () => import('@/views/home.vue')
            },
        ]
    },
    {
        path: '/user',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/user/list.vue')
            },
            {
                path: 'changePass',
                component: () => import('@/views/user/changepass.vue')
            },
        ]
    },
    {
        path: '/org',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/org/list.vue')
            }
        ]
    },
    {
        path: '/role',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/role/list.vue')
            }
        ]
    },
    {
        path: '/sysconfig',
        component: Main,
        children: [
            {
                path: 'submenu',
                component: () => import('@/views/sysconfig/submenu.vue')
            },
            {
                path: 'sysconfig',
                component: () => import('@/views/sysconfig/sysconfig.vue')
            }
        ]
    },
    {
        path: '/jurisdiction',
        component: Main,
        children: [
            {
                path: '',
                component: () => import('@/views/common/jurisdiction.vue')
            },
        ]
    },
    {
        path: '/creator',
        component: () => import('@/views/common/creator.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

const LOGIN_PAGE_NAME = 'Login'

router.beforeEach((to, from, next) => {
    // if(to.path == '/creator' || to.path.startsWith("/wv")){
    //     return next()
    // }
    // const token = sessionStorage.getItem("U_TOKEN")
    // if (!token && to.name !== LOGIN_PAGE_NAME) {
    //     console.log("去登录页")
    //     //未登录 跳转的页面不是登录页
    //     return next({
    //         name: LOGIN_PAGE_NAME
    //     })
    // } else if (!token && to.name === LOGIN_PAGE_NAME) {
    //     //未登陆 跳转的页面是登录页
    //     return next()
    // } else if (token && to.name === LOGIN_PAGE_NAME) {
    //     // 已登录 跳转的页面是登录页
    //     return next({
    //         path: '/home'
    //     })
    // } else {
        return next()
    // }
})

router.afterEach(to => {
    window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) =>{
    if (to.meta.title) {
        document.title = to.meta.title;
    }else{
        window.document.title = config.title
    }
    next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

export default router
